// GENERATED by generateConfigRelease.js — do not edit.
// Client id handed to the PayPal JS SDK in CartModal. Switch environments by
// rebuilding: `npm run build-testing` or `npm run build-release`.

export const PAYPAL_CLIENT_ID = "AeUBpsIJtNCqe-CU5OBOH3PRZ6fiFqr-P0q_vYdh2wlX3fGq1j2NbNc6qMDQ-LmM2diIzXQg45cu0rqs";
export const PAYPAL_ENV: "live" | "sandbox" = "live";
